export default "__VITE_ASSET__cdf45318__"